import { render } from "./UserCenterChild.vue?vue&type=template&id=0fbc1410&scoped=true"
import script from "./UserCenterChild.vue?vue&type=script&lang=js"
export * from "./UserCenterChild.vue?vue&type=script&lang=js"

import "./UserCenterChild.vue?vue&type=style&index=0&id=0fbc1410&lang=scss&scoped=true"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbc1410"]])

export default __exports__